<template>
   <div class="announcement-backdrop" v-if="isVisible">
      <div class="announcement-wrapper">
         <div class="announcement-inner">
            <div id="announcement-close-btn" @click="handleClose"></div>
            <div class="announcement-content">
               <slot></slot>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "FeatureAnnouncement",
   props: {
      cookieName: {
         type: String,
         required: true,
      },
   },
   data() {
      return {
         isVisible: false,
      };
   },
   created() {
      this.checkCookie();
   },
   methods: {
      checkCookie() {
         const cookies = document.cookie.split(";");
         const cookieExists = cookies.some((cookie) => {
            return cookie.trim().startsWith(`${this.cookieName}=`);
         });
         this.isVisible = !cookieExists;
      },
      handleClose() {
         const expiryDate = new Date();
         expiryDate.setFullYear(expiryDate.getFullYear() + 1);
         document.cookie = `${this.cookieName}=true; expires=${expiryDate.toUTCString()}; path=/`;
         this.isVisible = false;
      },
   },
};
</script>

<style lang="scss" scoped>
.announcement-backdrop {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   background: var(--background-overlay);
   z-index: 999;

   .announcement-wrapper {
      width: 84vw;
      background-color: var(--surface-level-1);
      border-radius: 16px;
      position: relative;

      @media (min-width: 576px) {
         width: 25%;
      }
      @media (min-width: 768px) {
         width: 60vw;
      }
      @media (min-width: 992px) {
         width: 30vw;
      }

      #announcement-close-btn {
         width: 42px;
         height: 42px;
         border: 1px solid var(--gray-50);
         position: absolute;
         right: 2rem;
         top: 1.25rem;
         cursor: pointer;

         &::before,
         &::after {
            opacity: 0.75;
            content: "";
            width: 2.5px;
            height: 24px;
            display: block;
            border-radius: 0.5rem;
            background-color: var(--gray-800);
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            margin: auto;
         }

         &::before {
            transform: rotate(45deg);
         }
         &::after {
            transform: rotate(-45deg);
         }
      }

      .announcement-inner {
         position: relative;
         padding: 2rem 4rem;

         .announcement-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            @media (min-width: 576px) {
               width: calc(100% - 16px);
            }
         }
      }
   }
}
</style>
